import script from "./FormTextArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormTextArea.vue?vue&type=script&setup=true&lang=ts"

import "./FormTextArea.vue?vue&type=style&index=0&id=24f8ab6c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24f8ab6c"]])

export default __exports__